import { FlexBox } from '@ardoq/layout';
import { ValueWarningMessage } from './ValueWarningMessage';

type RuleValueWrapperProps = {
  isNewConditionalFormatting: boolean;
  warningMessage?: string;
  children: React.ReactNode;
};

export const RuleValueWrapper = ({
  isNewConditionalFormatting,
  warningMessage,
  children,
}: RuleValueWrapperProps) => {
  if (!isNewConditionalFormatting) {
    return <>{children}</>;
  }

  return (
    <FlexBox flexDirection="column" gap="xsmall" flex={1}>
      <FlexBox gap="xsmall">{children}</FlexBox>
      <ValueWarningMessage message={warningMessage} />
    </FlexBox>
  );
};
